module.exports = __webpack_public_path__ + "static/media/logo-whirlpool.6c663132.png";